

















import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from './store/voiceClone'

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class voiceCloneSuccess extends Vue {
  price: string = ''
  type: string = ''
  // 是否为 IOS
  isIOS: boolean = false
  mounted() {
    debugger
    this.price = this.$route.query.price as string

    this.type = this.$route.query.type as string
  }
}

